import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { CSS_MQ } from "../../styles/breakpoints";
import React from "react";

import { css } from "@emotion/react";
import { FONTS } from "../../styles/fonts";

export const ImageAuthorLabel: ReactTFC<{
  label: string;
  photographyAuthorLabelTranslation: React.ReactNode;
}> = props => {
  return (
    <span
      css={css`
        ${FONTS.SwarovskiFutura300};
        color: ${CSS_COLORS.Grey3};

        font-size: 14px;
        letter-spacing: 0.7px;

        ${CSS_MQ.atLeastLg} {
          font-size: 16px;
          letter-spacing: 0.8px;
        }
      `}
    >
      {props.photographyAuthorLabelTranslation}: {props.label}
    </span>
  );
};
